exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".u1Vu5mfX6rvQX7{word-break:break-word}._1RXuPFQtuwFCtA{margin-top:8px}.xjDHW09-9u6lTu{margin-bottom:0}._3troIIxi_a1hqB{word-break:break-word}", ""]);

// exports
exports.locals = {
	"boardMemberRestrictionAlertMessaging": "u1Vu5mfX6rvQX7",
	"boardMemberRestrictionAlertConfirmButton": "_1RXuPFQtuwFCtA",
	"boardMemberRestrictionAlertCancelButton": "xjDHW09-9u6lTu",
	"boardMemberRestrictionAlertMembers": "_3troIIxi_a1hqB"
};